<!--
Auto-generated by: https://github.com/threlte/threlte/tree/main/packages/gltf
Command: npx @threlte/gltf@2.0.3 /Users/nrumak/Development/square-dt-labs/static/nrumak/card_modified.glb -d -u -s -t -T -P
-->

<script module lang="ts">
  import { Group, Material, Mesh } from 'three';
  import { T, type Props } from '@threlte/core';
  import { useGltf, useSuspense } from '@threlte/extras';
  import type { Snippet } from 'svelte';

  type GLTFResult = {
    nodes: {
      Mesh001: Mesh;
      Mesh001_1: Mesh;
      Mesh001_2: Mesh;
      Mesh001_3: Mesh;
    };
    materials: {};
  };

  let modelUrl = '';

  const load = () => {
    const suspend = useSuspense();
    return suspend(useGltf<GLTFResult>(modelUrl));
  };

  export const preload = async (url: string) => {
    modelUrl = url;
    try {
      await load();
    } catch (err) {
      return console.error('Failed to load model', err);
    }
  };
</script>

<script lang="ts">
  let {
    fallback,
    error,
    children,
    ref = $bindable(),
    matcaps,
    fallbackMaterial,
    ...props
  }: Props<Group> & {
    ref?: Group;
    matcaps: {
      card_front: Material;
      card_back: Material;
      card_front_metallic: Material;
      card_back_metallic: Material;
    };
    fallbackMaterial: Material;
    children?: Snippet<[{ ref: Group | undefined }]>;
    fallback?: Snippet;
    error?: Snippet<[{ error: Error }]>;
  } = $props();

  let materials: any = $state(matcaps);

  const gltf = load();

  $effect(() => {
    materials = matcaps ?? {
      card_front: fallbackMaterial,
      card_back: fallbackMaterial,
      card_front_metallic: fallbackMaterial,
      card_back_metallic: fallbackMaterial,
    };
  });
</script>

<T is={new Group()} bind:ref dispose={false} {...props}>
  {#await gltf}
    {@render fallback?.()}
  {:then gltf}
    <T.Group rotation={[Math.PI / 2, 0, 0]} scale={[0.01, 0.05, 0.01]}>
      <T.Mesh geometry={gltf.nodes.Mesh001_2.geometry} material={materials.card_back} renderOrder={1} />
      <T.Mesh geometry={gltf.nodes.Mesh001.geometry} material={materials.card_back_metallic} renderOrder={0} />
      <T.Mesh geometry={gltf.nodes.Mesh001_3.geometry} material={materials.card_front} />
      <T.Mesh geometry={gltf.nodes.Mesh001_1.geometry} material={materials.card_front_metallic} />
    </T.Group>
  {:catch err}
    {@render error?.({ error: err })}
  {/await}
  {@render children?.({ ref })}
</T>
